import { TimeOffReviewDecision } from '../time-off-review';

/**
 * Wire format for the review (approve/decline) decision sent to
 * PUT /api/time-off/requests/review.
 */
export enum TimeOffReviewDecisionDTO {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
}

export interface ReviewTimeOffApprovalRequest {
  requestId: number;
  decision: TimeOffReviewDecisionDTO;
  /** Optional free-text reason — sent for both approve and decline. */
  comment?: string;
}

/**
 * Domain-level params accepted by the `reviewTimeOffRequest` API function and
 * the `useReviewTimeOffRequest` mutation. Mapped to {@link ReviewTimeOffApprovalRequest}
 * (wire format) inside the API layer.
 */
export interface ReviewTimeOffRequestParams {
  requestId: number;
  decision: TimeOffReviewDecision;
  /** Optional reason — sent for both approve and decline. */
  comment?: string;
}
